export default __webpack_public_path__ + "static/media/pdf-display-luxury.f05cda4a.pdf";